import { useRef } from 'react';
import { v4 as uuid } from 'uuid';

/**
 * Render a UUID as a ref
 *
 * Allows for e.g. creating consistent and unique IDs for components
 * which survive re-renders
 *
 */
export const useUuid = () => useRef(uuid()).current;
